module.exports = __webpack_public_path__ + "static/media/Chicken1.b491539f.png";